import React from 'react';
import { motion } from 'framer-motion';
export function Navbar() {
  return <motion.nav initial={{
    opacity: 0,
    y: -20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className="fixed top-0 left-0 right-0 z-50 bg-gray-100/80 backdrop-blur-md border-b border-gray-200/50" data-id="element-247">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between" data-id="element-248">
        <div className="text-2xl font-heading font-bold text-slate-800 tracking-tight" data-id="element-249">
          Bedford.
        </div>
        <a href="" // TODO need to replace
      target="_blank" rel="noopener noreferrer" className="inline-block bg-slate-800 text-gray-50 px-8 py-2 font-medium text-sm tracking-wide uppercase transition-transform active:scale-95 hover:bg-slate-900 no-underline rounded-md" data-id="element-250">
          Schedule a Call
        </a>
      </div>
    </motion.nav>;
}